module.exports = {
  "country": "ES",
  "artist": "Ruth Lorenzo",
  "song": "Dancing in the Rain",
  "year": "2014",
  "place": "10",
  "spotify": "3ewuFERsiKOq5noSzJl6Uh"
};